import { Box, Button, Typography } from "@mui/material";
import { closeSnackbar, enqueueSnackbar } from "notistack";
import React, { useEffect, useMemo } from "react";
import MallScanner from "src/components/shared/ScanningInput";
import useWarehouseTransferDetail from "src/hooks/warehouse-transfer/useWarehouseTransferDetail";
import { v4 as uuid } from "uuid";

export default function useImportProdBody({ item, setProdList, prodList, setIndiProd, indiProd, setProdPick, scannerResetKey }) {
  const { data: detail, isLoading: detailLoading, mutate: detailMutate } = useWarehouseTransferDetail(item?._id);

  const header = [
    {
      id: uuid(),
      title: "STT",
      width: "15px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Sản phẩm",
      width: "80px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Số lượng",
      width: "30px",
      align: "center",
    },
    // {
    //   id: uuid(),
    //   title: "SL trả",
    //   width: "30px",
    //   align: "center",
    //   display: returnQty,
    // },
    {
      id: uuid(),
      title: "Đã scan",
      width: "30px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Thao tác",
      width: "35px",
      align: "center",
    },
  ];

  const handleFilterErrorCode = (key) => {
    setIndiProd((prev) => ({ ...prev, importItemCodes: undefined }));
    closeSnackbar(key);
  };

  const handleDisplayError = (error) => {
    const action = (key) => (
      <Button
        onClick={() => handleFilterErrorCode(key)}
        sx={{ bgcolor: "var(--black)" }}
        variant="contained"
        size="small"
      >
        Xác nhận
      </Button>
    );

    return enqueueSnackbar(
      <div>
        <p style={{ margin: 0 }}>Vui lòng xác nhận xoá các mã lỗi:</p>
        {!!error?.createFailed?.length && (
          <p style={{ margin: 0 }}>
            Mã lỗi: <strong>{String(error?.createFailed)}</strong>
          </p>
        )}
        {!!error?.duplicate?.length && (
          <p style={{ margin: 0 }}>
            Mã trùng: <strong>{String(error?.duplicate)}</strong>
          </p>
        )}
        {!!error?.existed?.length && (
          <p style={{ margin: 0 }}>
            Mã đã tồn tại: <strong>{String(error?.existed)}</strong>
          </p>
        )}
        {!!error?.invalidPrefix?.length && (
          <p style={{ margin: 0 }}>
            Sai format: <strong>{String(error?.invalidPrefix)}</strong>
          </p>
        )}
        {!!error?.notFound?.length && (
          <p style={{ margin: 0 }}>
            Mã không tồn tại: <strong>{String(error?.notFound)}</strong>
          </p>
        )}
        {!!error?.notInBatch?.length && (
          <p style={{ margin: 0 }}>
            Mã không tồn tại trong số lô: <strong>{String(error?.notInBatch)}</strong>
          </p>
        )}
        {!!error?.notMatch?.length && (
          <p style={{ margin: 0 }}>
            Mã không khớp: <strong>{String(error?.notMatch)}</strong>
          </p>
        )}
        {!!error?.imported?.length && (
          <p style={{ margin: 0 }}>
            <strong>{String(error?.imported)}</strong>
          </p>
        )}
        {error === "BatItemCodeExceed" && <p style={{ margin: 0, fontWeight: "bold" }}>Mã sản phẩm vượt quá số lượng cần nhập</p>}
      </div>,
      {
        variant: "warning",
        action,
        persist: true,
        preventDuplicate: true,
        anchorOrigin: { vertical: "top", horizontal: "center" },
      },
    );
  };

  useEffect(() => {
    if (!!item?.warehouseTransfer) {
      setProdList(
        item?.warehouseTransfer?.map((v, i) => {
          return {
            ...v,
            no: i + 1,
            prod: `${v?.productModel?.product?.name} (${v?.productModel?.name})`,
            progress: "",
            scanned: "",
            scanner: <Typography align="center">{v?.scanner ?? "-"}xxxxx</Typography>,
          };
        }),
      );
    }
    if (!!item?.transferDetails) {
      setProdList(
        item?.transferDetails?.map((v, i) => {
          return {
            ...v,
            no: i + 1,
            // prod: `${v?.productModel?.product?.name} (${v?.productModel?.name})`,
            progress: v?.qty,
            code: !!v?.itemCodes?.length ? String(v?.itemCodes) : "-",
            scanned: v?.itemCodes?.length ?? 0,
            scanner: <Typography align="center">{v?.scanner ?? "-"}xxxxx</Typography>,
          };
        }),
      );
    }
    if (!!detail?.data?.transferDetails) {
      setProdList(
        detail?.data?.transferDetails?.map((v, i) => {
          return {
            ...v,
            no: i + 1,
            prod: (
              <Box>
                <Typography variant="body2">
                  {v?.productModel?.product?.name} ({v?.productModel?.name})
                </Typography>
                <Typography sx={{ fontSize: "10px", fontStyle: "italic", fontWeight: "bold" }}>({v?.batch?.code})</Typography>
              </Box>
            ),
            progress: (
              <Typography
                textAlign="center"
                variant="body2"
              >
                {Number(v?.qty)}
              </Typography>
            ),
            return: v?.returnQty ?? 0,
            code: "-",
            require: v?.importedQty + v?.returnQty === Number(v?.qty),
            scanned: `${v?.importedQty ?? 0}/${Number(v?.qty ?? 0)}`,
            scanner: (
              <Box
                width="fit-content"
                minWidth="150px"
                mx="auto"
              >
                <MallScanner
                  key={`${v?._id}-${scannerResetKey}`}
                  label={v.totalExported === v.qty ? "Scan lại" : "Scan"}
                  hideEnter
                  getValue={setIndiProd}
                  value={indiProd}
                  extendState={v}
                  code="importItemCodes"
                  onCreate={() => setProdPick(v)}
                  full={v?.importedQty === Number(v?.qty ?? 0)}
                  fullLabel="Đã scan đủ"
                  disabledProcess
                  disabled={v.totalExported === v.qty}
                />
              </Box>
            ),
          };
        }),
      );
    }
  }, [item?.transferDetails, item?.warehouseTransfer, detailLoading, detail?.data?.transferDetails, scannerResetKey, setProdList]);

  const sortData = ["no", "prod", "progress", "scanned", "isFinished", "scanner"];

  const isFull = useMemo(() => {
    if (detail?.data?.totalQty === 0 || detail?.data?.totalExported === 0) return false;
    if (detail?.data?.totalQty === detail?.data?.totalExported) return true;
  }, [detail?.data?.totalQty, detail?.data?.totalExported]);

  return { header, bodyList: prodList, sortData, loading: detailLoading, detailMutate, detail, handleDisplayError, isFull };
}
